import { breakpoints, matchBreakpoint } from "../common/utils";

(() => {
  const navMobileBtn = $(".c-aside-sidebar-nav");
  const navMobileBtnFilter = $(".open-filters-js");
  const navCategory = $(".c-aside-sidebar__category");
  const sidebar = $(".c-aside-sidebar");
  const navCatH = $(".c-aside-filters").innerHeight();
  const navFiltersH = $(".c-aside-sidebar__category").innerHeight();
  const navFilters = $(".c-aside-filters");
  const asideH = navCatH + navFiltersH;
  let isOpen = false;
  const appHeight = () => {
    const doc = document.documentElement;

    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };

  const opanFiltersNavMobile = self => {
    if (isOpen) {
      isOpen = false;
    } else {
      isOpen = true;
      self.addClass("opened");
      sidebar.addClass("show");
      $("body").addClass("backdrop");
      navFilters.addClass().removeClass("active");
      navFilters.addClass("active");
      navMobileBtn.addClass("show-filters");
    }
  };

  const opanCatNavMobile = self => {
    sidebar.css("height", "calc( 100vh - 14 - " + sidebar.offset().top + "px)");
    if (navMobileBtn.hasClass("show-filters")) {
      navMobileBtnFilter.removeClass("opened");
      sidebar.removeClass("show");
      $("body").removeClass("backdrop");
      navFilters.removeClass("active");
      navMobileBtn.removeClass("show-filters");
      isOpen = false;
    } else {
      self.toggleClass("opened");
      sidebar.toggleClass("show-category");
      $("body").toggleClass("backdrop");
      navCategory.toggleClass("active");
      if (isOpen) {
        isOpen = false;
      } else {
        isOpen = true;
      }
    }
  };

  const callFiltersNavMobile = () => {
    if (matchBreakpoint(breakpoints.lg, "max")) {
      navMobileBtnFilter.on("click", function(e) {
        sidebar.css("height", "calc( 100vh - " + sidebar.offset().top + "px)");
        opanFiltersNavMobile($(this));
      });
    } else {
      isOpen = false;
    }
  };

  const callCategoryNavMobile = () => {
    if (matchBreakpoint(breakpoints.lg, "max")) {
      navMobileBtn.on("click", function(e) {
        opanCatNavMobile($(this));
      });
    }
  };

  $(document).ready(() => {
    appHeight();
    callCategoryNavMobile();
    callFiltersNavMobile();
  });
  $(window).on("resize", () => {
    appHeight();
    callCategoryNavMobile();
    callFiltersNavMobile();
  });
})();
